import * as React from "react";
import styled, { css } from "styled-components";
import * as _ from "lodash";

import { useDrop } from "src/core/drops/hooks";
import { useTransactionApi } from "src/modules/payment/api/transactions.api";
import { LoadingSpinner } from "src/library/components/LoadingSpinner";
import { Text } from "src/library/components/Text/Text";

import TransactionRow from "./TransactionRow";

const TransactionsDashboardWidget: React.ReactFCWithChildren = () => {
  const [ getTransactionsRes, getTransactionsReq ] = useTransactionApi("LIST_TRANSACTIONS");
  const [ { drop } ] = useDrop();

  React.useEffect(() => {
    if (drop) {
      getTransactionsReq({
        pagination: {
          offset: 0,
          page: 0,
          sort: [ [ "createdAt", "ASC" ] ],
          limit: 10
        },
        filters: { branchId: drop.id }
      });
    }
  }, [ drop, getTransactionsReq ]);

  return (
    <TransactionsDashboardWidgetWrapper>
      {getTransactionsRes.pending ? (
        <LoadingSpinner
          type="circular-pulse"
          size={30}
        />
      ) : (
        <div className="transactions-list">
          {getTransactionsRes.data?.result.length ? _.map(getTransactionsRes.data.result, transaction => (
            <TransactionRow transaction={transaction} />
          )) : (
            <Text>
              You have no recent payments
            </Text>
          )}
        </div>
      )}
    </TransactionsDashboardWidgetWrapper>
  );
};

export default TransactionsDashboardWidget;

const TransactionsDashboardWidgetWrapper = styled.div`
  ${({ theme }) => css`
    height: 100%;
    background: ${theme.colors.white};
    position: relative;

    .transactions-list {
      overflow-y: scroll;
      height: 100%;
    }

    .unpaid-order {
      width: 100%;
      padding: ${theme.spacing.padding.sm};
      border: 2px solid ${theme.colors.lightGrey};
      margin-bottom: ${theme.spacing.margins.sm};
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      
      .order-info {
        display: flex;
        flex-direction: row;
      }

      .info-row {
        display: flex;
        flex-direction: column;
        margin-right: ${theme.spacing.margins.sm};
      }
    }
  `}
`;
